import { NetworkIntegritySummaryResult } from "@app/projects/results/networkIntegrity/networkIntegritySummaryResult";
import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import { JSX, useContext, useEffect, useState } from "react";
import { Widget, WidgetLoading } from "./Widget";
import { NetworkIntegrityFilterContext } from "../filters";
import NetworkIntegrityService from "../networkIntegrityService";

const NetworkSummaryWidget = (): JSX.Element => {
    const projectContext = useContext(CountyProjectContext);
    const filterContext = useContext(NetworkIntegrityFilterContext);
    const networkIntegrityService = new NetworkIntegrityService();

    const [networkSummaryResult, setNetworkSummaryResult] = useState<NetworkIntegritySummaryResult>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const projectDate = projectContext.runConfiguration.dateCreated;

    useEffect(() => {
      setLoading(true);
        async function fetchSummaryResults() {
          try {
            const filter = projectContext.runConfiguration.adequacyTemplateCollectionId ? filterContext.providerType : 'Network';
            const result = await networkIntegrityService.getNetworkSummaryResult(projectContext.project.projectId, projectContext.runConfiguration.projectRunConfigurationId, filter);
            setNetworkSummaryResult(result);
          } finally {
            setLoading(false);
          };   
        };
        fetchSummaryResults();
    }, [projectContext.project.projectId, projectContext.runConfiguration.projectRunConfigurationId, filterContext.providerType]);

    if (loading)
      return (<WidgetLoading/>);

    return (
      <Widget title='Network Summary' asOfDate={projectDate}>
          {networkSummaryResult &&
            <>
                  <div className="d-flex flex-column align-items-center mt-4 mb-4">
                    <div>
                        <h2 className="mb-0">{networkSummaryResult.uniqueProviders.toLocaleString()}</h2>
                    </div>
                    <p className="mt-0">unique providers at</p>
                </div>

                <div className="d-flex flex-column align-items-center mt-2 mb-4">
                    <h2 className="mb-0">{networkSummaryResult.uniqueLocations.toLocaleString()}</h2>
                    <p className="mb-0 mt-0">unique locations</p>
                    <p className="mt-0 color-logan">({networkSummaryResult.accessPoints.toLocaleString()} total access points)</p>
                </div>
            </>}
        </Widget>);
}

export { NetworkSummaryWidget };